module.exports = __webpack_public_path__ + "img/foodics.ffa1b06a.png";